var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearchBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customer-final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_search",
    fill: "#0059FF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_search_white",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filled_Version"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,18 C11.131,18 13.09,17.25 14.633,16.008 L22.291,23.705 C22.68,24.098 23.312,24.1 23.705,23.709 C24.098,23.318 24.098,22.686 23.709,22.295 L16.041,14.588 C17.264,13.053 18,11.111 18,9 C18,4.037 13.963,0 9,0 C4.037,0 0,4.037 0,9 C0,13.963 4.037,18 9,18 Z M9,2 C12.859,2 16,5.139 16,9 C16,12.859 12.859,16 9,16 C5.139,16 2,12.859 2,9 C2,5.139 5.139,2 9,2 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchBlue);
export default __webpack_public_path__ + "static/media/icon_search_blue.0faf6722bd06fbd7be97e42843ef6018.svg";
export { ForwardRef as ReactComponent };